<template>
	<div>
		<h1>404 Something is missing...</h1>
		<router-link class="underlineHover" to="/">Go Home</router-link>
	</div>
</template>
<script>
export default {
  name: 'NotFoundPage',
  mounted(){
    this.$API.title="Error";
  }
}
</script>